const mp = new Map();
  mp.set(2023, [
    {
      paperNo: 132,
      title: " A two-photon responsive hydroxyphenylquinazolinone (HPQ)-based fluorescent organic nanoprodrug for H2S release against oxidative stress",
      overview:  require('../images/paper132.jpeg'),
      collaborator: " Amrita Chaudhuri,Tara Singa,Bikash Chandra Jena,Maniklal Shee, Prasanta Kumar Datta, Mahitosh Mandal and N D Pradeep Singh,",
      link: " https://doi.org/10.1039/D2CC05768A",
      linkTitle: "  Chem. Commun., just accepted "

    },
    {
      paperNo: 131,
      title: "β-Carboline-Norfloxacin Nanoconjugates as Antibacterial Nanophotocages for the Delivery of Norfloxacin and Singlet Oxygen",
      overview: require('../images/paper131.jpeg'),
      collaborator: "Antara Sikder,Saugat Mondal, Rabiya, Pritha Biswas,Subham Pal, Ramkrishna Sen and N. D. Pradeep Singh",
      link: "https://pubs.acs.org/doi/10.1021/acsanm.2c03349",
      linkTitle: "ACS Appl. Nano Mater"

    },
    {
      paperNo: 130,
      title: "Spatial specific delivery of combinational chemotherapeutics to combat intratumoral heterogeneity",
      overview: require('../images/journal of control release sir.jpg'),
      collaborator: "Kewei Wang, Maolin Jiang, Jielian Zhou, Yansong Dong, Ye Liu, Qingyu Zong, Puja Sandbhor, N.D. Pradeep Singh, Youyong Yuan",
      link: "https://pubs.acs.org/doi/10.1021/acsanm.2c03349",
      linkTitle: "Journal of Controlled Release 2022, just accepted "
    },
    {
      paperNo: 129,
      title: "Dihydropyrrolo[3,2-b]pyrrole-3,6-dicarbaldehyde-Based Two-Photon-Responsive Nanoparticles for Effective Photodynamic Therapy",
      overview: require('../images/amit acs nano.jpeg'),
      collaborator: "Sk. Sheriff Shah, Amit Kumar Singh, Saptarshi Banerjee, Tara Singha, Asha V Nair, Mamata Ojha, Arindam Mondal, Prasanta Kumar Datta, and N. D. Pradeep Singh",
      link: "https://doi.org/10.1021/acsanm.2c01805",
      linkTitle: "ACS Appl. Nano Mater., 2022, just accepted."
    },
    {
      paperNo: 128,
      title: "Photogenerated Azido Radical Mediated Oxidation: Access to Carbonyl Functionality from Alcohols, Alkylarenes, and Olefins via Organophotoredox",
      overview: require('../images/Manik adv syn catal.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1002/adsc.202200242",
      linkTitle: "ACS Appl. Nano Mater. 2022"
    },
    {
      paperNo: 127,
      title: " Visible Light-Responsive Delivery of Two Anticancer Drugs Using Single-Component Fluorescent Organic Nanoparticles",
      overview:  require('../images/Souvik 1.jpeg'),
      collaborator: " Souvik Ray, Saptarshi Banerjee, Amit Kumar Singh, Mamata Ojha, Arindam Mondal and N D Pradeep Singh,",
      link: "https://doi.org/10.1021/acsanm.2c01515",
      linkTitle: "   ACS Appl. Nano Mater. 2022, just accepted. "
      
    },
    {
      paperNo: 126,
title: " Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations,",
overview:  require('../images/chem soc rev.jpg'),
collaborator: " Maniklal Shee and N D Pradeep Singh,",
link: "https://doi.org/10.1039/D1CS00494H",
linkTitle: "   Chem. Soc. Rev., 2022, 51, 2255-2312."
    },
    {
      paperNo: 125,
      title: " Green Light-Activated Single-Component Organic Fluorescence-Based Nano-Drug Delivery System for Dual Uncaging of Anticancer Drugs,",
      overview:  require('../images/amit ACS Bio.png'),
      collaborator: " Amit Kumar Singh, Saptarshi Banerjee, Asha V Nair, Souvik Ray, Mamata Ojha, Arindam Mondal, and N D Pradeep Singh,",
      link: "https://doi.org/10.1021/acsabm.1c01241",
      linkTitle: " ACS Appl. Bio Mater. 2022, 5, 1202�1209. "

    },
    {
      paperNo: 124,
      title: "  Switching photorelease to singlet oxygen generation by oxygen functionalization of phenothiazine photocages,",
      overview:  require('../images/mamata chem comm.png'),
      collaborator: " Mamata Ojha, Moumita Banerjee, Souvik Ray,  Amit Kumar Singh,  Anakuthil Anoop and N D Pradeep Singh,",
      link: "https://doi.org/10.1039/D1CC06950K",
      linkTitle: " Chem. Commun., 2022, 58, 2754-2757. "
    },
    {
      paperNo: 123,
      title: " NIR-Responsive Lysosomotropic Phototrigger: An AIE + ESIPT Active Naphthalene-Based Single-Component Photoresponsive Nanocarrier with Two-Photon Uncaging and Real-Time Monitoring Ability,",
      overview:  require('../images/Biswajit ACS applied.png'),
      collaborator: " Biswajit Roy, Rakesh Mengji, Samrat Roy, Bipul Pal, Avijit Jana, and N D Pradeep Singh,",
      link: "https://doi.org/10.1021/acsami.1c19022",
      linkTitle: " ACS Appl. Mater. Interfaces 2022, 14, 4862�4870. "

    },
    {
      paperNo: 122,
title: " One- and Two-Photon Uncaging of Carbon Monoxide (CO) with Real-Time Monitoring: On-Demand Carbazole-Based Dual CO-Releasing Platform to Test over Single and Combinatorial Approaches for the Efficient Regression of Orthotopic Murine Melanoma In Vivo,",
overview:  require('../images/venky JMC.png'),
collaborator: " Yarra Venkatesh, Venugopal Vangala, Rakesh Mengji, Amrita Chaudhuri, Sayantan Bhattacharya, Prasanta Kumar Datta, Rajkumar Banerjee, Avijit Jana, and N D Pradeep Singh,",
link: "https://doi.org/10.1021/acs.jmedchem.1c00750",
linkTitle: " J. Med. Chem., 2022, 65, 1822�1834. "

    }
  ])
  mp.set(2022, [
    {
      paperNo: 132,
      title: " A two-photon responsive hydroxyphenylquinazolinone (HPQ)-based fluorescent organic nanoprodrug for H2S release against oxidative stress",
      overview:  require('../images/paper132.jpeg'),
      collaborator: " Amrita Chaudhuri,Tara Singa,Bikash Chandra Jena,Maniklal Shee, Prasanta Kumar Datta, Mahitosh Mandal and N D Pradeep Singh,",
      link: " https://doi.org/10.1039/D2CC05768A",
      linkTitle: "  Chem. Commun., just accepted "

    },
    {
      paperNo: 131,
      title: "β-Carboline-Norfloxacin Nanoconjugates as Antibacterial Nanophotocages for the Delivery of Norfloxacin and Singlet Oxygen",
      overview: require('../images/paper131.jpeg'),
      collaborator: "Antara Sikder,Saugat Mondal, Rabiya, Pritha Biswas,Subham Pal, Ramkrishna Sen and N. D. Pradeep Singh",
      link: "https://pubs.acs.org/doi/10.1021/acsanm.2c03349",
      linkTitle: "ACS Appl. Nano Mater"

    },
    {
      paperNo: 130,
      title: "Spatial specific delivery of combinational chemotherapeutics to combat intratumoral heterogeneity",
      overview: require('../images/journal of control release sir.jpg'),
      collaborator: "Kewei Wang, Maolin Jiang, Jielian Zhou, Yansong Dong, Ye Liu, Qingyu Zong, Puja Sandbhor, N.D. Pradeep Singh, Youyong Yuan",
      link: "https://pubs.acs.org/doi/10.1021/acsanm.2c03349",
      linkTitle: "Journal of Controlled Release 2022, just accepted "
    },
    {
      paperNo: 129,
      title: "Dihydropyrrolo[3,2-b]pyrrole-3,6-dicarbaldehyde-Based Two-Photon-Responsive Nanoparticles for Effective Photodynamic Therapy",
      overview: require('../images/amit acs nano.jpeg'),
      collaborator: "Sk. Sheriff Shah, Amit Kumar Singh, Saptarshi Banerjee, Tara Singha, Asha V Nair, Mamata Ojha, Arindam Mondal, Prasanta Kumar Datta, and N. D. Pradeep Singh",
      link: "https://doi.org/10.1021/acsanm.2c01805",
      linkTitle: "ACS Appl. Nano Mater., 2022, just accepted."
    },
    {
      paperNo: 128,
      title: "Photogenerated Azido Radical Mediated Oxidation: Access to Carbonyl Functionality from Alcohols, Alkylarenes, and Olefins via Organophotoredox",
      overview: require('../images/Manik adv syn catal.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1002/adsc.202200242",
      linkTitle: "ACS Appl. Nano Mater. 2022"
    },
    {
      paperNo: 127,
      title: " Visible Light-Responsive Delivery of Two Anticancer Drugs Using Single-Component Fluorescent Organic Nanoparticles",
      overview:  require('../images/Souvik 1.jpeg'),
      collaborator: " Souvik Ray, Saptarshi Banerjee, Amit Kumar Singh, Mamata Ojha, Arindam Mondal and N D Pradeep Singh,",
      link: "https://doi.org/10.1021/acsanm.2c01515",
      linkTitle: "   ACS Appl. Nano Mater. 2022, just accepted. "
      
    },
    {
      paperNo: 126,
title: " Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations,",
overview:  require('../images/chem soc rev.jpg'),
collaborator: " Maniklal Shee and N D Pradeep Singh,",
link: "https://doi.org/10.1039/D1CS00494H",
linkTitle: "   Chem. Soc. Rev., 2022, 51, 2255-2312."
    },
    {
      paperNo: 125,
      title: " Green Light-Activated Single-Component Organic Fluorescence-Based Nano-Drug Delivery System for Dual Uncaging of Anticancer Drugs,",
      overview:  require('../images/amit ACS Bio.png'),
      collaborator: " Amit Kumar Singh, Saptarshi Banerjee, Asha V Nair, Souvik Ray, Mamata Ojha, Arindam Mondal, and N D Pradeep Singh,",
      link: "https://doi.org/10.1021/acsabm.1c01241",
      linkTitle: " ACS Appl. Bio Mater. 2022, 5, 1202�1209. "

    },
    {
      paperNo: 124,
      title: "  Switching photorelease to singlet oxygen generation by oxygen functionalization of phenothiazine photocages,",
      overview:  require('../images/mamata chem comm.png'),
      collaborator: " Mamata Ojha, Moumita Banerjee, Souvik Ray,  Amit Kumar Singh,  Anakuthil Anoop and N D Pradeep Singh,",
      link: "https://doi.org/10.1039/D1CC06950K",
      linkTitle: " Chem. Commun., 2022, 58, 2754-2757. "
    },
    {
      paperNo: 123,
      title: " NIR-Responsive Lysosomotropic Phototrigger: An AIE + ESIPT Active Naphthalene-Based Single-Component Photoresponsive Nanocarrier with Two-Photon Uncaging and Real-Time Monitoring Ability,",
      overview:  require('../images/Biswajit ACS applied.png'),
      collaborator: " Biswajit Roy, Rakesh Mengji, Samrat Roy, Bipul Pal, Avijit Jana, and N D Pradeep Singh,",
      link: "https://doi.org/10.1021/acsami.1c19022",
      linkTitle: " ACS Appl. Mater. Interfaces 2022, 14, 4862�4870. "

    },
    {
      paperNo: 122,
title: " One- and Two-Photon Uncaging of Carbon Monoxide (CO) with Real-Time Monitoring: On-Demand Carbazole-Based Dual CO-Releasing Platform to Test over Single and Combinatorial Approaches for the Efficient Regression of Orthotopic Murine Melanoma In Vivo,",
overview:  require('../images/venky JMC.png'),
collaborator: " Yarra Venkatesh, Venugopal Vangala, Rakesh Mengji, Amrita Chaudhuri, Sayantan Bhattacharya, Prasanta Kumar Datta, Rajkumar Banerjee, Avijit Jana, and N D Pradeep Singh,",
link: "https://doi.org/10.1021/acs.jmedchem.1c00750",
linkTitle: " J. Med. Chem., 2022, 65, 1822�1834. "

    }
  ])

  mp.set(2021, [
    {
      paperNo: 121,
title: " Small Two-Photon Organic Fluorogenic Probes: Sensing and Bioimaging of Cancer Relevant Biomarkers,",
overview:  require('../images/Amit review.png'),
collaborator: " Amit Kumar Singh, Asha V Nair, and N D Pradeep Singh,",
link: " https://doi.org/10.1021/acs.analchem.1c04306",
linkTitle: " Anal. Chem., 2022, 94, 177�192. "
    },
    {
      paperNo: 120,
      title: " Recent Advances on Stimuli-Responsive Combination Therapy against Multidrug-Resistant Bacteria and Biofilm,",
      overview:  require('../images/antara review.png'),
      collaborator: " Antara Sikder, Amrita Chaudhuri, Saugat Mondal and N D Pradeep Singh,",
      link: " https://pubs.acs.org/doi/full/10.1021/acsabm.1c00150",
      linkTitle: " ACS Appl. Bio Mater., 2021, 4, 4667�4683 (Review). "
    },
    {
      paperNo: 119,
title: " Ground-State Proton-Transfer (GSPT)-Assisted Enhanced Two-Photon Uncaging from a Binol-based AIE-Fluorogenic Phototrigger,",
overview:  require('../images/Bisu OL.png'),
collaborator: " Biswajit Roy, Samrat Roy, Moumita Kundu, Somnath Maji, Bipul Pal, Mahitosh Mandal and N D Pradeep Singh,",
link: " https://pubs.acs.org/doi/10.1021/acs.orglett.1c00445",
linkTitle: " Org. Lett. 2021, 23, 2308�2313. "

    },
    {
      paperNo: 118,
title: " Single component photoresponsive fluorescent organic nanoparticles: a smart platform for improved biomedical and agrochemical applications,",
overview:  require('../images/chem comm feature article.png'),
collaborator: " Amrita Chaudhuri,   Amrita Paul,   Antara Sikdar  and  Pradeep ND Singh,",
link: " https://pubs.rsc.org/en/content/articlelanding/2021/cc/d0cc07183h#!divAbstract",
linkTitle: " Chem. Commun., 2021, 57, 1715-1733 (Feature Article). "
    },
    
  ]);

  mp.set(2020, [
    {
      paperNo: 117,
title: " Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions,",
overview:  require('../images/manik review.png'),
collaborator: " Maniklal Shee  and  N D Pradeep Singh,",
link: " https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
linkTitle: "   Catal. Sci. Technol., 2021, 11, 742-767 (Minireview). "
    },
    {
      paperNo: 116,
title: " A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring,",
overview:  require('../images/amit chemcomm.png'),
collaborator: " Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N D Pradeep Singh,",
link: " https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
linkTitle: " Chem. Commun., 2020, 56, 9986-9989. "
    },
    {
      paperNo: 115,
title: " A Natural Alkaloid, �-Carboline, as a One- and Two-Photon Responsive Fluorescent Photoremovable Protecting Group: Sequential Release of the Same or Different Carboxylic Acids,",
overview:  require('../images/antara ol.png'),
collaborator: " Antara Sikder, Moumita Banerjee, Tara Singha, Saugat Mondal, P K Datta, Anakuthil Anoop and N D Pradeep Singh,",
link: " https://pubs.acs.org/doi/10.1021/acs.orglett.0c02549",
linkTitle: " Org. Lett. 2020, 22, 6998�7002. "

    },
    {
      paperNo: 114,
title: " Mitochondria-localized in situ generation of rhodamine photocage with fluorescence turn-on enabling cancer cell-specific drug delivery triggered by green light,",
overview:  require('../images/amrita paul chemcomm.png'),
collaborator: " Amrita Paul, Rakesh Mengji, Manoranjan Bera, Mamata Ojha, Avijit Jana and N D Pradeep Singh,",
link: " https://pubs.rsc.org/en/content/articlelanding/2020/cc/d0cc03524f#!divAbstract",
linkTitle: " Chem. Commun., 2020, 56, 8412-8415. "

    },
    {
      paperNo: 113,
title: " Photocatalytic Conversion of Benzyl Alcohols/Methyl Arenes to Aryl Nitriles via H-Abstraction by Azide Radical,",
overview:  require('../images/manik2.png'),
collaborator: " Maniklal Shee, Sk Sheriff Shah and N D Pradeep Singh,",
link: " https://doi.org/10.1002/chem.202001332",
linkTitle: " Chemistry�A European Journal, 2020, 26, 14070-14074. "
    },
    {
      paperNo: 112,
title: " Improved tumor-specific therapeutic strategy by spatio-temporal in situ formation of Cu(II)-complex, leading to prompt cell apoptosis via photoactivation of prodrug,",
overview:  require('../images/AC chemcomm.png'),
collaborator: " Amrita Chaudhuri, Rakesh Mengji, Yarra Venkatesh, Avijit Jana and N D Pradeep Singh,",
link: "https://pubs.rsc.org/en/content/articlelanding/2020/cc/d0cc00667j#!divAbstract",
linkTitle: " Chem. Commun., 2020,56, 4559-4562. "

    },
    {
      paperNo: 111,
title: " Organophotoredox Assisted Cyanation of Bromoarenes via Silyl-Radical-Mediated Bromine Abstractions,",
overview:  require('../images/manik chemcomm.png'),
collaborator: " Maniklal Shee, Sk Sheriff Shah and N D Pradeep Singh,",
link: " https://doi.org/10.1039/D0CC00163E",
linkTitle: " Chem. Commun., 2020,56, 4240-4243. "
    },
    {
      paperNo: 110,
title: " Direct Oxygenation of C�H Bonds through Photoredox and Palladium Catalysis,",
overview:  require('../images/joc sheriff.png'),
collaborator: " Sk Sheriff Shah, Maniklal Shee, Amit Kumar Singh, Amrita Paul and N D Pradeep Singh,",
link: " https://pubs.acs.org/doi/10.1021/acs.joc.9b03197",
linkTitle: " J. Org. Chem. 2020, 85, 3426-3439. "
    },
    {
      paperNo: 109,
title: " Organophotoredox Mediated Amide Synthesis by Coupling Alcohol and Amine via Aerobic Oxidation of Alcohol,",
overview:  require('../images/sheriff amide.png'),
collaborator: " Sk Sheriff Shah, Maniklal Shee, Yarra Venkatesh, Amit Kumar Singh, Samya Samanta, and N D Pradeep Singh,",
link: " https://doi.org/10.1002/chem.201904924",
linkTitle: " Chemistry�A European Journal, 2020, 26, 3703-3708. "

    },
    {
      paperNo: 108,
title: " Quinoline H2S donor Decorated Fluorescent Carbon Dots: Visible Light Responsive H2S Nanocarriers,",
overview:  require('../images/mano JMCB.png'),
collaborator: " Manoranjan Bera, Somnath Maji, Amrita Paul, Bikash Kumar Sahoo, Tapas Kumar Maiti and N D Pradeep Singh,",
link: "https://pubs.rsc.org/en/Content/ArticleLanding/2020/TB/C9TB02157D#!divAbstract",
linkTitle: "J. Mater. Chem. B, 2020, 8, 1026-1032. "

    }
  ]
  );
  mp.set(2019, [
    {
      paperNo: 107,
title: " Wavelength-Orthogonal Photocleavable Monochromophoric Linker for Sequential Release of Two Different Substrates,",
overview:  require('../images/venky ol.png'),
collaborator: " Yarra Venkatesh, Amrita Chaudhuri, Saugat Mondal, Sk Sheriff Shah, N D Pradeep Singh,",
link: "https://pubs.acs.org/doi/10.1021/acs.orglett.9b04323",
linkTitle: "Org. Lett. 2020, 22, 295-299. "

    },
    {
      paperNo: 106,
title: " Stepwise dual stimuli triggered dual drug release by a single naphthalene based two-photon chromophore to reverse MDR for alkylating agents with dual surveillance in uncaging steps,",
overview:  require('../images/biswajit.png'),
collaborator: "  Biswajit Roy, Moumita Kundu, Amit Kumar Singh, Tara Singha, Sayantan Bhattacharya, Prasanta Kumar Datta, Mahitosh Mandal and N D Pradeep Singh,",
link: "http://pubs.rsc.org/en/content/articlelanding/2019/cc/c9cc05604a#!divAbstract",
linkTitle: "Chem. Commun., 2019, 55, 13140-13143. "

    },
    
    {
      paperNo: 105,
      title: "Water Soluble Light Activated Hydrogen Sulfide Donor Induced by Excited State Meta Effect",
      overview: require('../images/mano obc 1.png'),
      collaborator: "Manoranjan Bera , Somnath Maji , Amrita Paul, Souvik Ray, Tapas Kumar Maiti and N. D. Pradeep Singh",
      link: "http://pubs.rsc.org/en/Content/ArticleLanding/2019/OB/C9OB01502G#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 104,
title: " Real-time monitoring of photo-activated hydrogen persulfide donor for biological entities,",
overview:  require('../images/cahaudhuri obc.png'),
collaborator: "  Amrita Chaudhuri, Yarra Venkatesh, Bikash Chandra Jena, Krishna Kalyani Behara, Mahitosh Mandal, and N D Pradeep Singh,",
link: "http://pubs.rsc.org/en/content/articlelanding/2019/ob/c9ob01982k#!divAb",
linkTitle: "Org. Biomol. Chem., 2019, 17, 8800-8805. "

    },
    {
      paperNo: 103,
title: " One- and Two-Photon Activated Cysteine Persulfide Donors for Biological Targeting,",
overview:  require('../images/JOC chaudhuri didi.png'),
collaborator: "  Amrita Chaudhuri, Yarra Venkatesh, Joyjyoti Das, Moumita Gangopadhyay, Tapas K Maiti and N D Pradeep Singh,",
link: "http://doi.org/10.1021/acs.joc.9b01224",
linkTitle: "J. Org. Chem. 2019, 84, 18, 11441-11449. "
    },
    {
      paperNo: 102,
title: " o-Hydroxycinnamate for Sequential Photouncaging of Two Different Functional Groups and its Application in Releasing Cosmeceuticals  ,",
overview:  require('../images/amrita paul obc.png'),
collaborator: "  Amrita Paul, Manoranjan Bera, Prakhar Gupta and N D Pradeep Singh,",
link: "http://pubs.rsc.org/en/content/articlelanding/2019/ob/c9ob01148j#!divAbstract",
linkTitle: "Org. Biomol. Chem., 2019, 17, 7689-7693. "
    },
    {
      paperNo: 101,
title: " Single-Component Fluorescent Organic Nanoparticles with Four-Armed Phototriggers for Chemo-Photodynamic Therapy and Cellular Imaging ",
overview:  require('../images/pathiban.png'),
collaborator: " C Parthiban, Pavithra M, Vinod Kumar Reddy L, Dwaipayan Sen and N D Pradeep Singh ,",
link: "http://doi.org/10.1021/acsanm.9b00630",
linkTitle: "ACS Appl. Nano Mater., 2019, 2, 6, 3728-3734. "

    },
    {
      paperNo: 100,
title: " Push-Pull Stilbene: Visible Light Activated Photoremovable Protecting Group for Alcohols and Carboxylic Acids with Fluorescence Reporting Employed for Drug Delivery",
overview:  require('../images/OL 100 th.png'),
collaborator: " Amrita Paul, Angana Biswas, Sreyashi Sinha, Sk Sheriff Shah, Manoranjan Bera, Mahitosh Mandal and N D Pradeep Singh,",
link: "http://doi.org/10.1021/acs.orglett.9b00124",
linkTitle: "Org. Lett. 2019, 21, 9, 2968-2972. "
    },
    {
      paperNo: 99,
title: " One- and two-photon responsive sulfur dioxide donor: A combinatorial drug delivery for improved antibiotic therapy ,",
overview:  require('../images/obc 4.png'),
collaborator: " Yarra Venkatesh, Kumari Shanti Kiran, Sk Sheriff Shah, Amrita Chaudhuri, Satyahari Dey and N D Pradeep Singh,",
link: "http://pubs.rsc.org/en/content/articlelanding/2019/ob/c9ob00090a#!divAbstract",
linkTitle: "Org. Biomol. Chem., 2019, 17, 2640-2645 . "
    }
  ]
  );
  mp.set(2018, [
    {
      paperNo: 97,
title: " Squaric Acid-Coumarin-Chlorambucil:Photoresponsive Single-Component Fluorescent Organic Nanoconjugates for Self-Monitored Therapeutics,",
overview:  require('../images/paper93.png'),
collaborator: " Amrita Chaudhuri, Yarra Venkatesh, Joyjyoti Das, Krishna Kalyani Behara, Smita Mandal, Tapas K Maiti, and N D Pradeep Singh,",
link: "http://pubs.acs.org/doi/10.1021/acsanm.8b01533",
linkTitle: " ACS Appl. Nano Mater. 2018,  1, 11, 6312-6319. "
    },
    {
      paperNo: 96,
title: " Visible Light Triggered Fluorescent Organic Nanoparticles for Chemo-Photodynamic Therapy with Real Time Cellular Imaging,",
overview:  require('../images/Paper92.jpg'),
collaborator: " C Parthiban, Pavithra M, Vinod Kumar Reddy L, Dwaipayan Sen, Melvin Samuel S and N D Pradeep Singh,",
link: "http://pubs.acs.org/doi/10.1021/acsanm.8b01495",
linkTitle: " ACS Appl. Nano Mater. 2018,  1, 11, 6281-6288. "

    },
    {
      paperNo: 94,
      title: " Tetraphenylethylene conjugated p-Hydroxyphenacyl: Fluorescent Organic Nanoparticles for the Release of Hydrogen Sulfide under Visible light with Real-time Cellular Imaging,",
      overview:  require('../images/PAPER91.png'),
      collaborator: " C Parthiban, M Pavithra, L Vinod Kumar Reddy, Dwaipayan Sen, S Melvin Samuel and N D Pradeep Singh,",
      link: "http://pubs.rsc.org/en/content/articlelanding/2018/OB/C8OB01629A#!divAbstract",
      linkTitle: "Org. Biomol. Chem., 2018, 16, 7903-7909. "
      },
      {
      paperNo: 93,
      title: " Metallaphotoredox Mediated Csp2-H Hydroxylation of Arenes under Aerobic Condition,",
      overview:  require('../images/Picture90.png'),
      collaborator: " Sk Sheriff Shah, Amrita Paul, Manoranjan Bera, Yarra Venkatesh and N D Pradeep Singh,",
      link: "http://pubs.acs.org/doi/10.1021/acs.orglett.8b01973",
      linkTitle: "Org. Lett., 2018, 20, 5533�5536. "
      },
      {
      paperNo: 92,
      title: " NIR fluorescent organic nanoparticles for photoinduced nitric oxide delivery with self monitoring and real time reporting ability,",
      overview:  require('../images/Picture89.png'),
      collaborator: " Krishna Kalyani Behara, Y Rajesh, Amrita Chaudhuri, Moumita Gangopadhyay, Mahitosh Mandal and N D Pradeep Singh,",
      link: "http://pubs.rsc.org/en/content/articlelanding/2018/tb/c8tb01209a#!divAbstract",
      linkTitle: "J. Mater. Chem. B, 2018,6, 6042-6046. "
      },
      {
      paperNo: 91,
      title: " A dual-analyte probe: hypoxia activated nitric oxide detection with phototriggered drug release ability,",
      overview:  require('../images/paper 90.png'),
      collaborator: " Sandipan Biswas, Y Rajesh, Shrabani Barman, Manoranjan Bera, Amrita Paul, Mahitosh Mandal and N D Pradeep Singh,",
      link: "http://pubs.rsc.org/en/content/articlelanding/2014/CC/C8CC01854E#!divAbstract",
      linkTitle: "Chem. Commun., 2018,54, 7940-7943. "
      },
      {
        paperNo: 89,
        title: " Light Triggered Uncaging of Hydrogen Sulfide (H2S) with Real-Time Monitoring,",
        overview:  require('../images/paper 86.png'),
        collaborator: " Yarra Venkatesh, Joyjyoti Das, Amrita Chaudhuri, Anupam Karmakar, Tapas K Maiti, and N D Pradeep Singh,",
        link: "http://pubs.rsc.org/en/content/articlelanding/2018/cc/c8cc01172a#!divAbstract",
        linkTitle: "Chem. Commun., 2018, 54, 3106-3109. "
        },
      
  ]
  );
  mp.set(2017, [
    {
      paperNo: 85,
      title: " AIE + ESIPT Assisted Photorelease: Fluorescent Organic Nanoparticles for Dual Anticancer Drug Delivery with Real-Time Monitoring Ability,",
      overview:  require('../images/paper 84.png'),
      collaborator: " Sandipan Biswas, Rakesh Mengji, Shrabani Barman, Venugopal Vangala, Avijit Jana and N D Pradeep Singh,",
      link: "http://pubs.rsc.org/en/content/articlelanding/2017/cc/c7cc07692d#!divAbstract",
      linkTitle: "Chem. Commun., 2018, 54, 168-171. "
      },
      {
        paperNo: 84,
        title: " Cascade photocaging of diazeniumdiolate: A novel strategy for one and two photon triggered uncaging with real time reporting ,",
        overview:  require('../images/paper 80 re.png'),
        collaborator: " Krishna Kalyani Behara, Y Rajesh, Yarra Venkatesh, Bhaskar Rao Pinninti, Mahitosh Mandal, N D Pradeep Singh,",
        link: "http://pubs.rsc.org/en/content/articlelanding/2014/CC/C7CC04635A#!divAbstract",
        linkTitle: "Chem. Commun., 2017,  53, 9470 - 9473. "
        },
        {
        paperNo: 83,
        title: " Redox-responsive Xanthene-coumarin-chlorambucil-based FRET-guided theranostics for �activatable� combination therapy with real-time monitoring,",
        overview:  require('../images/paper 79.png'),
        collaborator: " Moumita Gangopadhyay, Rakesh Mengji, Amrita Paul, Yarra Venkatesh, Venugopal Vangala, Avijit Jana,  N D Pradeep Singh , ",
        link: "http://pubs.rsc.org/en/content/articlelanding/2017/cc/c7cc03241b#!divAbstract",
        linkTitle: "Chem. Commun., 2017, 53, 9109 - 9112."
        },
        {
        paperNo: 82,
        title: " An Environment Activatable Nanoprodrug: Two-Step Surveillance in the Anticancer Drug Release,",
        overview:  require('../images/paper 81.png'),
        collaborator: " Sandipan Biswas, Joyjyoti Das, Shrabani Barman, Bhaskara Rao Pinninti, Tapas K Maiti, and N D Pradeep Singh,",
        link: "http://pubs.acs.org/doi/10.1021/acsami.7b05132",
        linkTitle: "ACS Appl. Mater. Interfaces, 2017, 9, 28180�28184. "
        },
        {
        paperNo: 81,
        title: "Bimane: A Visible Light Induced Fluorescent Photoremovable Protecting Group for the Single and Dual Release of Carboxylic and Amino Acids,",
        overview:  require('../images/paper 75 new.jpg'),
        collaborator: " Amrita Chaudhuri, Yarra Venkatesh, Krishna Kalyani Behara, and N D Pradeep Singh, ",
        link: "",
        linkTitle: "Org. Lett. 2017, 19, 1598-1601."
        },
        {
        paperNo: 80,
        title: " Soft Ultraviolet (UV) Photopatterning and Metallization of Self-Assembled Monolayers (SAMs) Formed from the Lipoic Acid Ester of 2-Hydroxy-1-acetylpyrene: The Generality of Acid-CatalyzedRemoval of Thiol-on-Gold SAMs using Soft UV Light,",
        overview:  require('../images/paper 78.png'),
        collaborator: " Laurynas Pukenas, Panida Prompinit, B Nishitha, Daniel J Tate, N D Pradeep Singh, Richard J Bushby, Christoph W�lti, and Stephen D Evans, ",
        link: "",
        linkTitle: "ACS Appl. Mater. Interfaces 2017, 9, 18388-18397."
        },
        {
        paperNo: 79,
        title: " Pseudohalide Assisted Aerobic Oxidation of Alcohols in the Presence of Visible-Light,",
        overview:  require('../images/paper 85.png'),
        collaborator: " Sk Sheriff Shah and N D Pradeep Singh,",
        link: "https://www.sciencedirect.com/science/article/pii/S0040403917315113",
        linkTitle: "Tetrahedron Letters, 2018, 59  247�251."
        },
        {
        paperNo: 78,
        title: " ESIPT-Induced Fluorescent o-Hydroxycinnamate: Self-MonitoringPhototrigger for Prompt Image-Guided Uncaging of Alcohols,",
        overview:  require('../images/paper 83.png'),
        collaborator: " Amrita Paul, Rakesh Mengji, Olive Abraham Chandy, Surajit Nandi, Manoranjan Bera, Avijit Jana, Anakuthil Anoop and N D Pradeep Singh,",
        link: "http://pubs.rsc.org/en/content/articlelanding/2014/OB/C7OB02280H#!divAbstract",
        linkTitle: "Org. Biomol. Chem. 2017,�DOI:10.1039/C7OB02280H. "
        },
        {
        paperNo: 77,
        title: " Bis-Acetyl Carbazole: Photoremovable Protecting Group for Sequential Releaseof Two Different Functional Groups and its Application for Therapeutic Release,",
        overview:  require('../images/paper 82.png'),
        collaborator: " Yarra Venkatesh, Surajit Nandi, Maniklal Shee, Biswajit Saha, Anakuthil Anoop and N D Pradeep Singh,",
        link: "http://onlinelibrary.wiley.com/doi/10.1002/ejoc.201701253/abstract",
        linkTitle: "Eur. J. Org. Chem.�2017,�DOI:10.1002/ejoc.201701253. "
        },
        {
        paperNo: 76,
        title: "Wavelength Dependent, Sequentially Activated, Dual Anticancer Drug Delivery System with Photoinduced Fluorescence off-on for Real Time Imaging,",
        overview:  require('../images/paper 77 kk.png'),
        collaborator: " Krishna Kalyani Behara, Y Rajesh, Amrita Chaudhuri, Sandipan Biswas, Mahitosh Mandal, N D Pradeep Singh, ",
        link: "7BBE8FD4C706EF8A00FB5221C97301CD.f02t01",
        linkTitle: "ChemistrySelect 2017, 2, 4033 � 4038."
        },
        {
        paperNo: 75,
        title: "Spiropyran-Coumarin Platform: An Environment Sensitive Photoresponsive DrugDelivery System for efficient cancer therapy,",
        overview:  require('../images/paper 76.png'),
        collaborator: " Shrabani Barman, Joyjyoti Das, Sandipan Biswas, T K Maiti, and N D Pradeep Singh, ",
        link: "http://pubs.rsc.org/en/content/articlelanding/2017/tb/c7tb00379j#!divAbstract",
        linkTitle: "J. Mater. Chem. B, 2017, 5, 3940-3944. "
        },
        {
        paperNo: 74,
        title: "Coumarin Polycaprolactone Polymeric Nanoparticles: Light and Tumor microenvironment activated Cocktail Drug Delivery,",
        overview:  require('../images/karthik da jmc b 74.png'),
        collaborator: " S Karthik, Avijit Jana, M Selvakumar, Yarra Venkatesh, Amrita Paul, Sk Sheriff Shah, and N D Pradeep Singh, ",
        link: "",
        linkTitle: "J. Mater. Chem. B, 2017,5, 1734-1741."
        },
  ]
  );
  mp.set(2016, [
    {
      paperNo: 73,
      title: "A p-Hydroxyphenacyl�Benzothiazole�Chlorambucil Conjugate as a Real-Time-Monitoring Drug-Delivery System Assisted by Excited-State Intramolecular Proton Transfer,",
      overview:  require('../images/paper 68.png'),
      collaborator: " Shrabani Barman, Sourav K Mukhopadhyay, Sandipan Biswas, Surajit Nandi, Moumita Gangopadhyay, Satyahari Dey, Anakuthil Anoop, N D Pradeep Singh , ",
      link: "http://onlinelibrary.wiley.com/doi/10.1002/anie.201508901/epdf",
      linkTitle: "Angew. Chem. Int. Ed.2016, 55, 1 � 6."
      },
      {
      paperNo: 72,
      title: "Photocaging of Single and Dual (Similar or Different) Carboxylic and Amino Acids by Acetyl Carbazole and its Application as Dual Drug Delivery in Cancer Therapy,",
      overview:  require('../images/Paper 70.png'),
      collaborator: " Yarra Venkatesh, Y Rajesh, S Karthik, A C Chetan, Mahitosh Mandal, Avijit Jana, and N D Pradeep Singh, ",
      link: "http://pubs.acs.org/doi/abs/10.1021/acs.joc.6b02152",
      linkTitle: "J. Org. Chem. 2016, 81, 11168-11175."
      },
      {
      paperNo: 71,
      title: "Three Arm, Biotin-tagged Carbazole-Dicyanovinyl-Chlorambucil Conjugate: Simultaneous Tumor Targetting, Sensing and Photoresponsive Anticancer Drug Delivery,",
      overview:  require('../images/paper 69.png'),
      collaborator: " Yarra Venkatesh, S Karthik, Y Rajesh, Mahitosh Mandal, Avijit Jana, and N D Pradeep Singh, ",
      link: "http://onlinelibrary.wiley.com/journal/10.1002/(ISSN)1861-471X/accepted",
      linkTitle: "Chem. Asian J. 2016, 11, 3482 � 3486."
      },
      {
      paperNo: 70,
      title: "Single Component Image Guided 'On-demand' Drug Delivery System for Early Stage Prostate Cancer,",
      overview:  require('../images/paper 73.png'),
      collaborator: " Sandipan Biswas, Joyjyoti Das, Shrabani Barman, Sk Sheriff Shah, Moumita Gangopadhyay,Tapas K Maity, N D Pradeep Singh, ",
      link: "http://authors.elsevier.com/sd/article/S0925400517300084",
      linkTitle: "Sensors & Actuators: B. Chemical. DOI: 10.1016/j.snb.2017.01.008. "
      },
      {
      paperNo: 69,
      title: "Organic Nanoparticle-Based Fluorescent Chemosensor forSelective Switching ON and OFF of Photodynamic Therapy (PDT),",
      overview:  require('../images/paper 72.png'),
      collaborator: " Moumita Gangopadhyay, Avijit Jana, Y Rajesh, Manoranjan Bera, Sandipan Biswas, Nilanjana Chowdhury, Yanli Zhao, Mahitosh Mandal, and N D Pradeep Singh, ",
      link: "http://onlinelibrary.wiley.com/doi/10.1002/slct.201601380/abstract",
      linkTitle: "ChemistrySelect 2016, 1, 6523 � 6531."
      },
      {
      paperNo: 68,
      title: "Smart and Reusable Biopolymer Nanocomposite for Simultaneous Microalgal Biomass Harvesting and Disruption: Integrated Downstream Processing for a Sustainable Biorefinery,",
      overview:  require('../images/paper 71.png'),
      collaborator: " Ramalingam Dineshkumar, Amrita Paul, Moumita Gangopadhyay, N D Pradeep Singh, and Ramkrishna Sen, ",
      link: "http://pubs.acs.org/doi/abs/10.1021/acssuschemeng.6b02189",
      linkTitle: "ACS Sustainable Chem. Eng. 2016, DOI: 10.1021/acssuschemeng.6b02189. "
      },
      {
      paperNo: 67,
      title: "Fluorene�morpholine-based organic nanoparticles: lysosome-targeted pH-triggered two-photon photodynamic therapy with fluorescence switch on�off,",
      overview:  require('../images/paper 67.gif'),
      collaborator: " Moumita Gangopadhyay, Sourav K Mukhopadhyay, Sree Gayathri, Sandipan Biswas, Shrabani Barman, Satyahari Dey and N D Pradeep Singh , ",
      link: "http://pubs.rsc.org/en/content/articlepdf/2016/tb/c5tb02563j",
      linkTitle: "J. Mater. Chem. B, 2016, 4, 1862--1868."
      },
      {
        paperNo: 66,
        title: "Photoresponsive real time monitoring silicon quantum dots for regulated delivery of anticancer drugs,",
        overview:  require('../images/paper 66.jpg'),
        collaborator: " Amrita Paul, Avijit Jana, S Karthik, Manoranjan Bera, Yanli Zhao and N D Pradeep Singh , ",
        link: "http://pubs.rsc.org/en/content/articlepdf/2016/tb/c5tb02045j?page=search",
        linkTitle: "J. Mater. Chem. B, 2016,4, 521-528."
        },
        
      
  ]
  );
  mp.set(2015, [
    {
      paperNo: 65,
      title: "Photoresponsive polymers based on a coumarin moiety for the controlled release of pesticide 2,4- D,",
      overview:  require('../images/paper 65 toc.jpg'),
      collaborator: " Sanghamitra Atta, Amrita Paul, Rakesh Banerjee, Manoranjan Bera, Mohammed Ikbal, Dibakar Dhara and N D Pradeep Singh, ",
      link: "http://pubs.rsc.org/en/content/articlelanding/2015/ra/c5ra18944f#!divAbstract",
      linkTitle: "RSC Adv., 2015,5, 99968-99975."
      },
      {
      paperNo: 64,
      title: "Nano-pesticide formulation based on fluorescent organic photoresponsive nanoparticles: for controlled release of 2,4-D and real time monitoring of morphological changes induced by 2,4-D in plant systems,",
      overview:  require('../images/paper 64 toc.gif'),
      collaborator: " Sanghamitra Atta, Manoranjan Bera, Tirthartha Chattopadhyay, Amrita Paul, Mohammed Ikbal,   Mrinal K Maiti, N D Pradeep Singh, ",
      link: "http://pubs.rsc.org/en/content/articlepdf/2015/ra/c5ra17121k",
      linkTitle: "RSC Adv., 2015, 5, 86990-86996."
      },
      {
      paperNo: 63,
      title: "Simple and efficient coumarin-based colorimetric and fluorescent chemosensor for F- detection: An ON1-OFF-ON2 fluorescent assay,",
      overview:  require('../images/paper 63 tof.jpg'),
      collaborator: " Sandipan Biswas, Moumita Gangopadhyay, Shrabani Barman, Jit Sarkar, ND Pradeep Singh, ",
      link: "http://www.sciencedirect.com/science/article/pii/S0925400515302689",
      linkTitle: "Sensors and Actuators B: Chemical, 2015, 222, 823-828."
      },
      {
      paperNo: 62,
      title: "Coumarin-containing-star-shaped 4-armpolyethylene glycol: targeted fluorescent organic nanoparticles for dual treatment of photodynamic therapy and chemotherapy,",
      overview:  require('../images/C5PP00057B.gif'),
      collaborator: " Moumita Gangopadhyay, Tanya Singh, Krishna Kalyani Behara, S Karwa,S K Ghosh and N D Pradeep Singh, ",
      link: "http://pubs.rsc.org/en/content/articlepdf/2015/pp/c5pp00057b?page=search",
      linkTitle: "Photochem. Photobiol. Sci.,2015, 14, 1329."
      },
      {
      paperNo: 61,
      title: "Coumarin�benzothiazole�chlorambucil (Cou�Benz�Cbl) conjugate: an ESIPT based pH sensitive photoresponsive drug delivery system,",
      overview:  require('../images/c4tb02081.gif'),
      collaborator: " Shrabani Barman, Sourav K Mukhopadhyay, Moumita Gangopadhyay,Sandipan Biswas, Satyahari Dey and N D Pradeep Singh, ",
      link: "http://pubs.rsc.org/en/content/articlepdf/2015/tb/c4tb02081b",
      linkTitle: "i"
      },
      {
      paperNo: 60,
      title: "Vis/NIR light driven mild and clean synthesis of disulfides in the presence of Cu2(OH)PO4 under aerobic conditions,",
      overview:  require('../images/paper 60 toc.jpg'),
      collaborator: " Sk Sheriff Shah, S Karthik and N D Pradeep Singh, ",
      link: "http://pubs.rsc.org/en/content/articlepdf/2015/ra/c5ra05138j?page=search",
      linkTitle: "RSC Adv., 2015, 5, 45416."
      },
      {
      paperNo: 59,
      title: ", Targeted  Photoresponsive TiO2-Coumarin nanoconjugate for efficient Combination therapy  in MDA-MB-231 breast cancer cells: Synergic effect of Photodynamic Therapy  (PDT) and Anticancer drug Chlorambucil,",
      overview:  require('../images/481g.gif'),
      collaborator: " Moumita  Ganguly, Sourav K Mukhopadhyay,��  Karthik S,�� Sharabani Barman  and��� Pradeep ND Singh",
      link: "http://pubs.rsc.org/en/content/articlepdf/2015/md/c4md00481g",
      linkTitle: "Med.Chem.Commun.,2015, 6, 769�777."
      },
      {
      paperNo: 58,
      title: " Targeted, Image Guided Dually Locked Photoresponsive Drug Delivery System, ",
      overview:  require('../images/s karthik jmcb 2.gif'),
      collaborator: " Karthik S, Prashanth Kumar B N, Moumita Gangopadhyay, Mandal Mahitosh,Pradeep ND Singh,",
      link: "http://pubs.rsc.org/en/content/articlepdf/2015/tb/c4tb01583e",
      linkTitle: "J. Mater. Chem. B, 2015,3, 728-732."
      },
      
      
  ]
  );
  mp.set(2014, [
    {
      paperNo: 57,
      title: "Triplet Sensitized Photolysis of a Vinyl Azide: Direct Detection of a Triplet Vinyl Azide and Nitrene,",
      overview:  require('../images/jo-2014-01898p_0024.gif'),
      collaborator: " Sridhar Rajam, Abhijit V Jadhav, Qian Li, Sujan K Sarkar, Pradeep N   D Singh, Ahleah Rohr, Tamara C S Pace, Rui Li, Jeanette A Krause,   Cornelia Bohne, Bruce S Ault, and Anna D Gudmundsdottir, ",
      link: "http://pubs.acs.org/doi/abs/10.1021/jo501898p",
      linkTitle: "J. Org. Chem., 2014, 79 (19), pp 9325�9334"
      },
      {
      paperNo: 56,
      title: ", Synthesis and in  vitro evaluation of charge reversal photoresponsive quinoline tethered  mesoporous silica for targeted drug delivery, ",
      overview:  require('../images/C4TB01367K.gif'),
      collaborator: " S Karthik,�� Avijit Jana,�  Biswajit Saha,�� B Krishna  Kalyani,�� Sudip Kumar Ghosh,�� Yanli Zhao and�� N D Pradeep Singh",
      link: "http://pubs.rsc.org/en/content/articlepdf/2014/tb/c4tb01367k",
      linkTitle: "J. Mater. Chem. B, 2014,3, 728-732."
      },
      {
      paperNo: 54,
      title: ", Influence of functional derivatives of an amino-coumarin/ MWCNT composite organic hetero-junction on the photovoltaic  characteristics, ",
      overview:  require('../images/1-s2.0-S1369800114000043-gr2.jpg'),
      collaborator: " R K Sahoo, S Atta,  NDP Singh, C Jacob",
      link: "http://ac.els-cdn.com/S1369800114000043/1-s2.0-S1369800114000043-main.pdf?_tid=4c384452-218c-11e5-9454-00000aacb35e&acdnat=1435932396_c97aefaadde50473c81028071a8a308f",
      linkTitle: "Materials Science in Semiconductor Processing, 2014, 25, 279-285."
      },
{
  paperNo: 53,
  title: " 1-Acetylpyrene�Salicylic Acid: Photoresponsive Fluorescent Organic Nanoparticles for the Regulated Release of a Natural Antimicrobial Compound, Salicylic Acid, ",
  overview:  require('../images/am-2014-00965n_0010.gif sravs acs appl in.gif'),
  collaborator: " Shrabani Barman , Sourav K Mukhopadhyay , Krishna Kalyani Behara , Satyahari Dey , and N D Pradeep Singh",
  link: "http://pubs.acs.org/doi/pdf/10.1021/am500965n",
  linkTitle: "ACS Appl. Mater. Interfaces, 2014, 6, 7045-7054."
  },
  {
  paperNo: 52,
  title: " 1-Acetylferroceneoxime based Photoacid Generators: Application towards   sol-gel transformation and development of photoresponsive polymer for   controlled wettability and patterned surfaces, Salicylic Acid, ",
  overview:  require('../images/ferro.jpg'),
  collaborator: " Mohammed Ikbal, Rakesh Banerjee, Shrabani Barman, Sanghamitra Atta, DibakarDhara, N D Pradeep Singh",
  link: "http://pubs.rsc.org/en/content/articlepdf/2014/tc/c4tc00203b",
  linkTitle: "J. Mater. Chem. C, 2014, 2, 4622-4630."
  },
  {
  paperNo: 51,
  title: " Benzo[a]acridinyl   methyl esters as pH Sensitive Fluorescent Photoactive precursors:   Synthesis, Photophysical, Photochemical and Biological Application, ",
  overview:  require('../images/obc.jpg'),
  collaborator: " Mohammed Ikbal,Biswajit Saha,Sharabani Barman,Sanghamitra Atta,Debranjan Banerjee,Sudip Ghosh, NDPradeep Singh",
  link: "http://pubs.rsc.org/en/content/articlepdf/2014/ob/c3ob42600a",
  linkTitle: "Org. Biomol. Chem., 2014, 12, 3459�3469."
  },
  
  ]
  );
  mp.set(2013, [
    {
      paperNo: 48,
      title: "Synthesis, photochemistry, DNA cleavage/binding and cytotoxic   properties of fluorescent quinoxaline and quinoline hydroperoxides.",
      overview:  require('../images/1-s2.0-S1011134413002546-fx1.jpg'),
      collaborator: " Nilanjana Chowdhury, Moumita Gangopadhyay, S Karthik, Mithu Baidya, SK Ghosh,ND Pradeep Singh",
      link: "http://www.sciencedirect.com/science/article/pii/S1011134413002546",
      linkTitle: "Journal of Photochemistry and Photobiology B: Biology 130, 2014,188-198"
      },
      {
      paperNo: 47,
      title: " Photocontrolled Nuclear-Targeted Drug Delivery by Single Component   Photoresponsive Fluorescent Organic Nanoparticles of Acridin-9-methanol.",
      overview:  require('../images/bc-2013-1828-1839.gif'),
      collaborator: " Avijit Jana, Biswajit   Saha, Deb Ranjan Banerjee, Sudip Kumar Ghosh, Kim Truc Nguyen, Xing Ma ,   Qu Qiuyud Yanli Zhao and N D Pradeep Singh;",
      link: "http://pubs.acs.org/doi/full/10.1021/bc400170r",
      linkTitle: " Bioconjugate Chem.,2013, 24 (11) pp 1828-1839"
      },
      {
        paperNo: 46,
        title: " Photoresponsive quinoline tethered fluorescent carbon dots for regulated anticancer drug delivery.",
        overview:  require('../images/GA.gif'),
        collaborator: " S Karthik, Biswajit Saha, Sudip Kumar Ghosh and N D Pradeep Singh;",
        link: "https://pubs.rsc.org/en/journals/articlecollectionlanding?sercode=cc&themeid=b936fc92-c179-45ba-aa33-a800b4003f7a",
        linkTitle: "Highlighted in 20th Anniversary of the CRSI: Celebrating Indian Chemistry in ChemComm."
        },
        {
        paperNo: 45,
        title: "Photoresponsive Coumarin-Tethered Multifunctional Magnetic Nanoparticles for Release of Anticancer Drug.",
        overview:  require('../images/karthik01.png'),
        collaborator: " S Karthik, Nagaprasad Puvvada, B N Prashanth Kumar, Shashi Rajput, Amita Pathak, Mahitosh Mandal,and N D Pradeep Singh",
        link: "http://pubs.acs.org/doi/full/10.1021/am401059k",
        linkTitle: " ACS Appl. Mater. Interfaces 2013, 5, 5232-5238 "
        },
        {
        paperNo: 44,
        title: " Fluorescent Photoremovable precursors (acridin-9-ylmethyl)ester:   Synthesis, Photophysical, Photochemical and Biological applications.",
        overview:  require('../images/GA.jpg'),
        collaborator: " Avijit Jana , Biswajit Saha , Karthik S , Sharabani Barman , Mohammed Ikbal , Sudip Ghosh and Pradeep ND Singh;",
        link: "http://www.ncbi.nlm.nih.gov/pubmed/23545754",
        linkTitle: " Photochemical &amp; Photobiological Sciences, 2013, 12(6), 1041-52"
        },
        {
        paperNo: 43,
        title: " 1,3,5-Trisubstituted benzenes as fluorescent photoaffinity probes for human carbonic anhydrase II capture.",
        overview:  require('../images/c3cc38251f-f1.gif'),
        collaborator: " Partha Sarathi Addy , Baisakhee Saha , N D Pradeep Singh , Amit K Das , Jacob T Bush ,Clarisse Lejeune , Christopher J Schofield and Amit Basak ",
        link: "http://pubs.rsc.org/en/content/articlehtml/2013/cc/c3cc38251f",
        linkTitle: "Chem Comm, 49, 1930-1932, 2013"
        },
        {
        paperNo: 42,
        title: " Photoremovable protecting groups as controlled-release device for sex pheromone.",
        overview:  require('../images/GA02.jpg'),
        collaborator: "Sanghamitra Atta ,  Mohammed Ikbal ,  Nishitha Boda ,  Samiran S Gauri and N D Pradeep Singh; ",
        link: "http://pubs.rsc.org/en/content/articlelanding/2013/pp/c2pp25118c/unauth#%21divAbstract",
        linkTitle: " Photochem. Photobiol. Sci.2013 12(2),393-403"
        },
        
      
  ]
  );
  mp.set(2012, [
    {
      paperNo: 41,
      title: "Synthesis,   Photophysical and Photochemical Properties of Photoacid Generators Based on N-Hydroxyanthracene-1,9-dicarboxyimide and Their Application toward Modification of Silicon Surfaces.",
      overview:  require('../images/iqbal01.jpg'),
      collaborator: " Mohammed Ikbal, Rakesh Banerjee, Dibakar Dhara, Anakuthil Anoop, N D Pradeep Singh",
      link: "http://pubs.acs.org/doi/full/10.1021/jo301367y",
      linkTitle: "J. Org. Chem. 2012, 77, 10557-10567"
      },
      {
      paperNo: 40,
      title: " 1-(Hydroxyacetyl)pyrene a new fluorescent phototrigger for cell imaging and caging of alcohols, phenol and adenosine.",
      overview:  require('../images/GA01.jpg'),
      collaborator: " Avijit Jana ,  Biswajit Saha ,  Mohammed Ikbal and Sudip Ghosh, ND Pradeep Singh",
      link: "http://pubs.rsc.org/en/content/articlelanding/2012/pp/c2pp25091h/full#%21divAbstract",
      linkTitle: "Photochem. Photobiol. Sci.2012,11, 1558-1566"
      },
      {
      paperNo: 39,
      title: "Azido carbonyl compounds as DNA cleaving agents.",
      overview:  require('../images/nilanjana01.jpg'),
      collaborator: " Nilanjana Chowdhury, Sansa Dutta, Skarthik, Swagata Dasgupta, Anakuthil Anoop, ND Pradeep Singh",
      link: "http://pubs.rsc.org/en/Content/ArticleLanding/2012/PP/c2pp25033k",
      linkTitle: " Journal of Photochemistry and Photobiology B: Biology, 115, 25-34 (2012)"
      },
      {
      paperNo: 38,
      title: "Development of 1-Hydroxy-2(1H)-quinolone based photoacid generators and photoresponsive polymer surfaces&quot.",
      overview:  require('../images/iqbal02.jpg'),
      collaborator: " Mohammed Ikbal, Rakesh Banerjee, Dibakar Dhara, Anakuthil Anoop, N D Pradeep Singh",
      link: "http://onlinelibrary.wiley.com/doi/10.1002/chem.201104065/full",
      linkTitle: "Chemistry - A European Journal 18(38), 11968,11 (2012) "
      },
      {
        paperNo: 37,
        title: "Photoinduced DNA cleavage by anthracene based hydroxamic acids.",
        overview:  require('../images/paper 37.jpg'),
        collaborator: "Nilanjana Chowdhury, Swagata Dasgupta, ND Pradeep Singh ",
        link: "http://www.sciencedirect.com/science/article/pii/S0960894X12006968",
        linkTitle: "Bioorganic Medicinal Chemistry Letters,22 (14), 4668-4671 (2012)"
        },
        {
        paperNo: 36,
        title: "Perylene-3-ylmethanol:Fluorescent Organic Nanoparticles as a Single-Component Photoresponsive Nanocarrier with Real-Time Monitoring of Anticancer Drug Release.",
        overview:  require('../images/avijit01.jpg'),
        collaborator: "Avijit Jana, K Sanjana P Devi, Tapas K Maiti, and N D Pradeep Singh ",
        link: "http://pubs.acs.org/doi/pdf/10.1021/ja302482k",
        linkTitle: "J.Am.Chem.Soc. 2012, 134 (18), 7656-7659"
        },
        
      
  ]
  );
  mp.set(2011, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2010, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2009, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2008, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2007, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2006, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    
    }

  ]
  )
  mp.set(2005, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2004, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2003, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2002, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2001, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  )
  mp.set(2000, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  );
  mp.set(1999, [
    {
      paperNo: 117,
      title: "Cooperative photoredox and palladium catalysis: recent advances in various functionalization reactions",
      overview: require('../images/manik review.png'),
      collaborator: " Maniklal Shee  and  N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2021/cy/d0cy02071k#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 116,
      title: "A two-photon responsive naphthyl tagged p-hydroxyphenacyl based drug delivery system: uncaging of anti-cancer drug in the phototherapeutic window with real-time monitoring",
      overview: require('../images/amit chemcomm.png'),
      collaborator: "Amit Kumar Singh, Moumita Kundu, Samrat Roy, Biswajit Roy, Sk. Sheriff Shah, Asha V Nair, Bipul Pal, Mahitosh Mondal and N. D. Pradeep Singh",
      link: "https://pubs.rsc.org/en/content/articlelanding/2020/CC/D0CC01903H#!divAbstract",
      linkTitle: ""
    },
    {
      paperNo: 115,
      title: "Chemical versatility of azide radical: journey from a transient species to synthetic accessibility in organic transformations",
      overview: require('../images/chem soc rev.jpg'),
      collaborator: "Maniklal Shee and N. D. Pradeep Singh",
      link: "https://doi.org/10.1039/D1CS00494H",
      linkTitle: ""
    }
  ]
  );
  export default mp;